<template>
  <base-popup
      :popup-model="show"
      :title="formTitle"
      :valid="!valid"
      @onCancelButtonClick="closePopupHandler"
      @onSaveButtonClick="saveItemHandler"
  >
    <v-form
        :ref="formRef"
        v-model="valid"
        lazy-validation
        class="mt-5"
        enctype="multipart/form-data"
    >
      <v-row no-gutters>
        <v-col cols="12">
          <v-text-field
              v-model="currentItem.name"
              label="Name"
              prepend-icon="mdi-rename-box"
              outlined
              dense
              required
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="3">
          <v-subheader class="switch-btn-title">Status</v-subheader>
        </v-col>
        <v-col sm="8">
          <v-switch
              v-model="currentItem.status"
              color="primary"
              dense
              inset
              prefix="Status">
          </v-switch>
        </v-col>
      </v-row>
    </v-form>
  </base-popup>
</template>

<script>
import BasePopup from "./BasePopup";
import PopupMixin from "../mixins/Popup";
import GPAutoComplete from "@/components/GPAutoComplete";

export default {
  name: "ClientTypePopup",
  components: {GPAutoComplete, BasePopup},
  mixins: [PopupMixin],
  computed: {
    formTitle() {
      return this.isEditMode ? 'Edit Client Type' : 'Add Client Type';
    },
  }
}
</script>

<style scoped>

</style>